import React from "react";
import PropTypes from "prop-types";

// components
import ModalVideo from "../../components/ModalVideo/ModalVideo";
import { Image } from "../Image/Image";

// styles
import "./company-representation-block.scss";

const CompanyRepresentationBlock = ({
  backgroundImage,
  video,
  quote,
  name,
  position,
}) => {
  return (
    <div className="company-representation-block">
      <div className="company-representation-block__overlay" />
      <Image
        className="company-representation-block__background-image-desktop"
        fluid={backgroundImage}
      />
      <div className="company-representation-block__content-wrapper">
        {video && (
          <div className="company-representation-block__company-video">
            <div className="video">
              <ModalVideo
                videoId={"1"}
                posterImage={backgroundImage}
                video={video !== null ? video : false}
                text=""
              />
            </div>
          </div>
        )}
        <blockquote className="company-representation-block__quote">
          {quote}
        </blockquote>
        <span className="company-representation-block__meta">{name}</span>
        <span className="company-representation-block__meta">{position}</span>
      </div>
    </div>
  );
};

export default CompanyRepresentationBlock;

CompanyRepresentationBlock.defaultProps = {
  video: "",
  backgroundImage: {},
  quote: "",
  name: "",
  position: "",
};

CompanyRepresentationBlock.propTypes = {
  video: PropTypes.string,
  backgroundImage: PropTypes.object,
  quote: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
};
